import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ThreeDots } from "react-loader-spinner";
import { AuthContext } from "../Context/AuthContextProvider";
import { MdOutlineClose } from "react-icons/md";
import "./main.css";
import user_profile from "./../Assets/Media/LoginDropDown/profile1-svgrepo-com.png";
import domains from "./../Assets/Media/LoginDropDown/domain-registration-svgrepo-com.png";

export const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 340,
    maxWidth: 400,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "0px",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function MainHeaderDropdownMenu() {
  const { isAuth, logoutme, loginUser, formatDate } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  // Two flags so small & large avatars fall back independently when image fails
  const [smallImgFailed, setSmallImgFailed] = useState(false);
  const [largeImgFailed, setLargeImgFailed] = useState(false);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    setIsLoading(true);
    if (isAuth) {
      await logoutme({ email: loginUser.email_id });
      navigate("/Login");
    } else {
      navigate("/Login");
    }
    setIsLoading(false);
    handleClose();
  };

  const handleProfile = () => navigate("/Dashboard/Profile");
  const handleEditProfile = () => navigate("/Dashboard/EditAccountDetails");

  /**
   * getAvatarContent(size, fontSize, variant)
   * variant = "small" | "large"
   *
   * Returns:
   * - <img> when loginUser.profile_image exists and the corresponding imgFailed flag is false
   * - otherwise a letter div with identical wrapper classes so spacing stays consistent
   *
   * Important: wrapper classes must match your original layout to preserve alignment.
   */
  const getAvatarContent = (size = 40, fontSize = 20, variant = "small") => {
    const imgExists = Boolean(loginUser?.profile_image);
    const imgFailed = variant === "small" ? smallImgFailed : largeImgFailed;
    const setImgFailed = variant === "small" ? setSmallImgFailed : setLargeImgFailed;

    // Use the same wrapper for image and fallback so spacing/padding don't change
    // For small avatar (navbar) we keep a small padding, for large we use dashboard-header-profile-pic
    if (variant === "small") {
      // NAVBAR avatar wrapper
      return (
        <div
          className="w-[50px] h-[50px] rounded-full flex items-center justify-center"
          style={{ padding: 2, boxSizing: "border-box" }}
        >
          {imgExists && !imgFailed ? (
            <img
              src={loginUser.profile_image}
              alt=""
              onError={() => setImgFailed(true)}
              className="w-full h-full rounded-full object-cover"
              style={{ display: "block" }}
            />
          ) : (
            <div className="w-full h-full rounded-full bg-[#fbcb04] text-[24px] flex items-center justify-center text-[#311e17] font-bold">
              {loginUser?.username?.charAt(0).toUpperCase() || "U"}
            </div>
          )}
        </div>
      );
    }

    // LARGE avatar (dropdown header) wrapper
    return (
      <div className="w-[6rem] h-[6rem] rounded-full dashboard-header-profile-pic flex items-center justify-center overflow-hidden">
        {imgExists && !imgFailed ? (
          <img
            src={loginUser.profile_image}
            alt=""
            onError={() => setImgFailed(true)}
            className="w-full h-full rounded-full object-cover"
            style={{ display: "block" }}
          />
        ) : (
          <div className="w-full h-full rounded-full bg-[#fbcb04] flex items-center justify-center">
            <span className="text-[#311e17] text-[50px] font-bold">
              {loginUser?.username?.charAt(0).toUpperCase() || "U"}
            </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="text"
        disableElevation
        onClick={handleClick}
        className="nav-item1 "
        sx={{
          padding: "0px",
        }}
      >
        {getAvatarContent(40, 20, "small")}
      </Button>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box
          sx={{
            justifyContent: "space-between",
            display: "flex",
            margin: "0px",
            position: "relative",
          }}
        >
          <button
            onClick={handleClose}
            className="mt-[0px] absolute right-[10px] top-[10px]"
          >
            <MdOutlineClose className="dashboard-header-close-btn" />
          </button>
        </Box>

        <Box
          onClick={handleClose}
          sx={{
            gap: "16px",
            display: "flex",
            justifyContent: "center",
            padding: "24px 12px",
            paddingLeft: "24px",
            background:
              "linear-gradient(to right, #cca97cdb, #fcdb6a, #e2be6d)",
          }}
        >
          <div className="avatar">{getAvatarContent(96, 40, "large")}</div>

          <div className="flex justify-center flex-col align-items-left">
            <Typography
              variant="h2"
              sx={{
                fontWeight: "600",
                textTransform: "capitalize",
                color: "#311e17",
                maxWidth: "250px",
                height: "40px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {loginUser ? loginUser.username : "User"}
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              sx={{
                display: "flex",
                gap: "6px",
                alignItems: "center",
                marginTop: "8px",
              }}
            >
              <EmailOutlinedIcon sx={{ fontSize: "16px" }} />
              {loginUser ? loginUser.email_id : "User Email"}
            </Typography>
            {loginUser && loginUser.mobile_number ? (
              <Typography
                variant="body2"
                gutterBottom
                sx={{ display: "flex", gap: "6px", alignItems: "center" }}
              >
                <PhoneAndroidOutlinedIcon sx={{ fontSize: "16px" }} />
                {loginUser.mobile_number}
              </Typography>
            ) : null}
          </div>
        </Box>

        <Box sx={{ padding: "12px", background: "#f8f6ee" }}>
          <MenuItem
            onClick={() => {
              handleClose();
              handleProfile();
            }}
            component={Link}
            to="/Dashboard/Profile"
            className="hover:text-black"
            sx={{
              padding: "12px",
              "&:hover": {
                background: "#ede7d4 !important",
                borderRadius: "8px !important",
              },
            }}
          >
            <ListItemIcon>
              <div className="!mr-0 !text-[50px] w-fit  icon-process p-[10px] rounded-[30px]">
                <img src={user_profile} alt="" className="w-[35px]" />
              </div>
            </ListItemIcon>
            <div className="flex flex-col ml-[12px]">
              <span className="text-[20px] font-bold !text-[#311e17]">
                My Profile
              </span>
              <span className="text-[14px] font-normal">
                Last Login:&nbsp;
                {loginUser.LastLogin && loginUser.LastLogin.length > 0
                  ? formatDate(
                      loginUser.LastLogin[loginUser.LastLogin.length - 1]
                        .attempt
                    )
                  : "Details unavailable"}
              </span>
            </div>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              handleProfile();
            }}
            component={Link}
            to="/Dashboard/Domains"
            className="hover:text-black"
            sx={{
              padding: "12px",
              "&:hover": {
                background: "#ede7d4 !important",
                borderRadius: "8px !important",
              },
            }}
          >
            <ListItemIcon>
              <div className="!mr-0 !text-[50px] w-fit  icon-process p-[10px] rounded-[30px]">
                <img src={domains} alt="" className="w-[35px]" />
              </div>
            </ListItemIcon>

            <div className="flex flex-col ml-[12px]">
              <span className="text-[20px] font-bold !text-[#311e17]">
                My Domains
              </span>
              <span className="text-[14px] font-normal">
                {loginUser.domains ? loginUser.domains.length : "0"}
                &nbsp;domains{" "}
              </span>
            </div>
          </MenuItem>
        </Box>

        <div
          className="flex justify-between items-center"
          style={{
            background:
              "linear-gradient(to right, #cca97cdb, #fcdb6a, #e2be6d)",
          }}
        >
          <button
            className="px-[24px] py-[8px] border-r  gap-[10px] flex gap-[4px] items-center w-[50%] hover:border-t-[4px] border-[#b99653]"
            onClick={() => {
              handleClose();
              handleEditProfile();
            }}
          >
            <EditOutlinedIcon />
            Edit Profile
          </button>
          <button
            onClick={handleLogout}
            className="px-[24px] py-[8px] w-[50%] gap-[10px] hover:border-t-[4px] border-[#b99653] flex "
          >
            {isLoading ? (
              <div className="w-full flex justify-center align-middle">
                <ThreeDots
                  color="black"
                  height={25}
                  width={40}
                  timeout={1000000}
                  className="text-center"
                />
              </div>
            ) : (
              <div className="flex">
                <div className="flex  flex-col justify-center align-center">
                  {" "}
                  <LogoutIcon />
                </div>

                <ListItemText primary="Logout" />
              </div>
            )}
          </button>
        </div>
      </StyledMenu>
    </div>
  );
}
